const contactForm = [
  {
    col: [12, 7, 7],
    name: 'name',
    label: 'Nombre',
  },
  {
    col: [12, 5, 5],
    name: 'identificationNum',
    label: 'DNI',
  },
];

export default contactForm;
